import { initData } from 'src/models/InitialData.model';

// resetSession restores a placeholder session rather than clearing it, and the placeholder's
// iid is a non-empty string — so a truthiness check reads "no exam" as an exam.
const NO_EXAM_ID = initData.tempSession.iid;

export const isExamInProgress = (iid: string | undefined): boolean =>
  Boolean(iid) && iid !== NO_EXAM_ID;
